module.exports = __webpack_public_path__ + "img/svg/app-store-button.7237220d141fc574e680a2bb012015ab.svg";